"use strict";

exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;


//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/lib/mixins/focus.js
// module id = 56
// module chunks = 0